
import { SnapshotInfo } from "@/types/snapshot";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class SnapshotItem extends Vue {
  @Prop({
    default() {
      return {};
    }
  })
  snapshot!: SnapshotInfo;

  @Prop({ default: false })
  selected!: boolean;
}
